module.exports = __webpack_public_path__ + "digitalassessments.svg?b66589a34677e176c6bdff475df2aa8b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/digitalassessments.svg
// module id = 146
// module chunks = 0